export enum TerrainEnum {
  NORMAL = "NORMAL",
  BUG = "BUG",
  GRASS = "GRASS", // TODO: Make this the generic type
  ROCK = "ROCK",
  FIRE = "FIRE",
  WATER = "WATER",
  ICE = "ICE",
  FLYING = "FLYING",
  ELECTRIC = "ELECTRIC",
  POISON = "POISON",
  PSYCHIC = "PSYCHIC",
  GROUND = "GROUND",
}
